export default __webpack_public_path__ + "static/media/agmLogoWhite2.cfa1ca3c.png";